import { Grid, TextField, Typography } from "@mui/material";
import { differenceInCalendarDays } from "date-fns";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const DayCountControl = () => {
  const { t } = useTranslation();
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const startDate = watch("startDate");
  const endDate = watch("endDate");
  const isEezyWork = watch("isEezyWork");
  const hasError = !!errors.dayCount;

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("workHistory:dayCount")}
        </Typography>
      </Grid>
      <Grid item container xs={9} alignItems="center">
        <Controller
          name="dayCount"
          control={control}
          rules={{
            required: { value: isEezyWork, message: t("common:requiredField") },
            min: { value: 0, message: t("common:invalidNumber") },
            validate: {
              maxByDateRange: (value) => {
                if (value === null || value === undefined || value === "")
                  return true;
                if (!startDate || !endDate) return true;
                const maxDays =
                  differenceInCalendarDays(endDate, startDate) + 1;
                if (maxDays < 0) return true;
                return value <= maxDays || t("common:invalidNumber");
              },
            },
          }}
          render={({ field: { name, value, onChange } }) => (
            <TextField
              autoComplete="off"
              fullWidth
              required
              name={name}
              size="small"
              type="number"
              value={value ?? ""}
              onChange={(event) =>
                onChange(
                  event.target.value === "" ? null : Number(event.target.value),
                )
              }
              error={hasError}
              inputProps={{ min: 0, step: 1 }}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default DayCountControl;
